import web from "@/core/middlewares/web";

let index = () => import(/* webpackChunkName: "multimedia" */ '@/views/multimedia/Index');
let create = () => import(/* webpackChunkName: "multimedia" */ '@/views/multimedia/Create');
let edit = () => import(/* webpackChunkName: "multimedia" */ '@/views/multimedia/Edit');

export default [
    {
        path: "/multimedia",
        name: "multimedia.index",
        component: index,
        meta: {
            middleware: web,
            permissions: ['multimedia:viewAny'],
            title: "چند رسانه‌ای"
        }
    },
    {
        path: "/multimedia/create",
        name: "multimedia.create",
        component: create,
        meta: {
            middleware: web,
            permissions: ['multimedia:create'],
            title: "ایجاد رسانه"
        }
    },
    {
        path: "/multimedia/:id",
        name: "multimedia.edit",
        component: edit,
        meta: {
            middleware: web,
            permissions: ['multimedia:update'],
            title: "ویرایش رسانه"
        }
    },
]
